<form *ngIf="structureGlobalForm" [formGroup]="structureGlobalForm">
  <div class="modal-body">
    <div class="row">
      <div class="mb-3 text-secondary col-12">
        <small class="form-text">Les champs marqués d'un <em class="text-danger">*</em> sont obligatoires. </small>
      </div>
      <div class="d-flex flex-row align-items-center flex-wrap col-12">
        <div class="d-flex flex-row align-items-center flex-wrap text-secondary ms-auto me-2">
          <div class="form-check form-switch">
            <input id="structureActive" class="form-check-input" type="checkbox" formControlName="active" />
            <label class="form-check-label" for="structureActive">Active</label>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center flex-wrap text-secondary">
          <div class="form-check form-switch">
            <input id="structurePortalVisibility" class="form-check-input" type="checkbox" formControlName="portalVisibility" />
            <label class="form-check-label" for="structurePortalVisibility">Public</label>
          </div>
        </div>
      </div>
      <div class="mb-3 text-secondary col-12">
        <label class="required">Nom</label>
        <input
          type="text"
          class="form-control"
          formControlName="label"
          [class.is-invalid]="submitted && structureGlobalForm.controls?.label?.invalid"
        />
        <small *ngIf="submitted && structureGlobalForm.controls?.label?.errors?.required" class="form-text text-danger"
          >Le nom de la structure est requis.</small
        >
        <small *ngIf="submitted && structureGlobalForm.controls?.label?.errors?.pattern" class="form-text text-danger"
          >Le nom de la structure n'est pas valide.</small
        >
        <small *ngIf="submitted && structureGlobalForm.controls?.label?.errors?.unavailable" class="form-text text-danger"
          >Le nom de la structure est déjà utilisé.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12">
        <label class="required">Dénomination sociale</label>
        <input
          type="text"
          class="form-control"
          formControlName="legalName"
          [class.is-invalid]="submitted && structureGlobalForm.controls?.legalName?.invalid"
        />
        <small *ngIf="submitted && structureGlobalForm.controls?.legalName?.errors?.required" class="form-text text-danger"
          >La Dénomination sociale est requise.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-xl-6">
        <label class="required">Identifiant IODAS</label>
        <input
          type="text"
          class="form-control"
          formControlName="idIODAS"
          [class.is-invalid]="submitted && structureGlobalForm.controls?.idIODAS?.invalid"
        />
        <small *ngIf="submitted && structureGlobalForm.controls?.idIODAS?.errors?.required" class="form-text text-danger"
          >L'Identifiant IODAS de la structure est requis.</small
        >
        <small *ngIf="submitted && structureGlobalForm.controls?.idIODAS?.errors?.unavailable" class="form-text text-danger"
          >L'Identifiant IODAS est déjà utilisé.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-xl-6">
        <label>Numéro SIRET</label>
        <input
          type="text"
          class="form-control"
          formControlName="SIRET"
          maxlength="14"
          [class.is-invalid]="submitted && structureGlobalForm.controls?.SIRET?.errors?.pattern"
        />
        <small *ngIf="submitted && structureGlobalForm.controls?.SIRET?.errors?.pattern" class="form-text text-danger"
          >Le numéro SIRET doit être composé de 14 chiffres.</small
        >
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-6">
        <label>Mail de contact</label>
        <input type="text" class="form-control" formControlName="contactEmail" />
      </div>
      <div class="mb-3 text-secondary col-12 col-lg-6">
        <label>Site internet</label>
        <input type="text" class="form-control" formControlName="website" />
      </div>
      <div class="mb-3 col-12">
        <label for="focus-areas" class="required">Domaine d'intervention</label>
        <ng-select
          id="focus-areas"
          formControlName="focusAreaIds"
          [items]="focusAreas"
          bindValue="id"
          [multiple]="true"
          [closeOnSelect]="false"
          groupBy="category"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          [class.is-invalid]="submitted && structureGlobalForm.controls?.focusAreaIds?.invalid"
        ></ng-select>
        <small *ngIf="submitted && structureGlobalForm.controls?.focusAreaIds?.errors?.required" class="form-text text-danger"
          >Le domaine d'intervention est requis.</small
        >
      </div>
      <div class="mb-3 col-12">
        <label>Présentation</label>
        <app-text-editor
          class="w-100"
          formControlName="presentation"
          [class.invalid]="submitted && structureGlobalForm.controls?.presentation?.invalid"
        ></app-text-editor>
      </div>
      <div class="mb-3 text-secondary col-12">
        <label>Logo de la structure</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            readonly="true"
            [class.is-invalid]="submitted && structureGlobalForm.controls?.fileName?.invalid"
            formControlName="fileName"
          />
          <label class="btn btn-secondary input-group-text">
            <span class="cursor-pointer">
              Parcourir...
              <input (change)="onFileChange($event?.target?.files)" type="file" style="display: none" accept=".jpg,.jpeg,.png,.bmp" /></span
          ></label>
        </div>
      </div>
    </div>
  </div>
</form>
